// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}
	window.scrollTo(0, 0);

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollW();
		window.lenis.on("scroll", ({ scroll }) => {
			window.currentScroll = scroll;

			scrollW();
		});

		if(document.getElementById('home')){
			if(document.querySelector('.top-content__logo.animate-logo ')){
				document.querySelector('.top-content__logo.animate-logo ').classList.remove('animate-logo');
			}
			setTimeout(() => {
				document.querySelector('.top-content.animate-background').classList.remove('animate-background');
			}, 1000);
			setTimeout(() => {
				document.getElementById('header').classList.remove('home-hidden-animation');
				if(document.querySelector('.top-content__tag-location.home-hidden-animation')){
					document.querySelector('.top-content__tag-location.home-hidden-animation').classList.remove('home-hidden-animation');
				}
				document.querySelector('.top-content__uvp.home-hidden-animation').classList.remove('home-hidden-animation');
				document.getElementById('home').classList.remove('no-scroll');
			}, 2800);
		}
	};

	window.lenis = new Lenis({
        duration: 1.2,
        smooth: true,
        smoothTouch: true
    });

    function raf(time) {
        window.lenis.raf(time);
        requestAnimationFrame(raf);
    }
	
	requestAnimationFrame(raf);


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	document.querySelectorAll('.btn:not(.reset), .btn-alt').forEach((button)=>{
		let span = document.createElement('span');
		span.setAttribute('aria-hidden', 'true');
		button.insertAdjacentElement('afterbegin', span);
	});

	if(document.querySelector('.signup-btn')){
		let textButton = document.querySelector('.signup-btn').textContent;
		let spanbtn = document.createElement('span');
		document.querySelector('.signup-btn').textContent = '';
		document.querySelector('.signup-btn').textContent = textButton;
		document.querySelector('.signup-btn').insertAdjacentElement('afterbegin', spanbtn);
	}

	if(document.querySelector('.form-module__submit button.btn')){
		let buttonsForms = document.querySelectorAll('.form-module__submit button.btn');
		buttonsForms.forEach((button)=>{
			let text = button.textContent;
			let span = document.createElement('span');
			button.innerHTML = "";
			button.textContent = text;
			button.insertAdjacentElement('afterbegin', span);
		})
	}


	if(document.querySelector('.menus-quad__filter')){
		let tabsMenu = document.querySelectorAll('.menus-quad__filter li');
		let allMenus = document.querySelectorAll('.menus-quad__container .menus-quad__menu');
		let lastClickMenu = null;

		tabsMenu.forEach((tab)=>{
			tab.addEventListener('click', ()=>{
				let menuId = tab.dataset.menu;
				if(lastClickMenu){
					lastClickMenu.classList.remove('active');
				}
				tab.classList.add('active');
				allMenus.forEach((menu)=>{
					menu.classList.toggle('hidden', menuId != menu.dataset.menu);
				})
				lastClickMenu = tab;
			})
		})

		tabsMenu[0].click();
	}

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

	document.querySelectorAll('.accordion').forEach((accordion) => {
		accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
			itemHead.addEventListener('click', (e) => {
				accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
					if (itemHead.parentNode !== item) item.classList.remove('open');
				});
				itemHead.parentNode.classList.toggle('open');
			});
		});
	});


	// menu accordion
	if(	document.querySelectorAll('.js-menu--accordion')) {
		let menuAccordion = document.querySelectorAll('.js-menu--accordion');
		menuAccordion.forEach(ele => {
			ele.addEventListener('click' , () => {
				ele.classList.toggle('open');
			})
		});
		
	}

	if(document.getElementById('menu-mobile')){

		document.querySelectorAll('.js-open-menu').forEach((button)=>{
			button.addEventListener('click',(e)=>{
				e.preventDefault();
				document.getElementById('menu-mobile').classList.add('show');
			})
		})

		document.querySelector('.close-menu').addEventListener('click',(e)=>{
			document.getElementById('menu-mobile').classList.remove('show');
		})
	}

	if(document.querySelector('.form-module-wrapper')){
		document.querySelectorAll('.form-module-wrapper').forEach((text) => {
			text.querySelector('.form-module').classList.add('animate-fade','top');
		});
	}

	if(document.querySelector('.text-modules-wrapper')){
		document.querySelectorAll('.text-modules-wrapper').forEach((text) => {
		text.querySelector('.text-modules').classList.add('animate-fade','top');
	});
	}

	if(document.querySelector('.global-sitemap')){
		document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
	}


})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}